import {broadcast} from "./communicator/AppCommunicator";

/**
 *  Send log to console and native app
 *  @param {any} - argument list is parsed automatically
 *  @return {void}
 */
function log( /* arguments */ )
{
    var logMessage = "";
    for(var i = 0; i < arguments.length; i++)
    {
        logMessage += " * " + (typeof arguments[i] === "string" ? arguments[i] : JSON.stringify(arguments[i])) + "\n";
    }
    console.log(logMessage);

    broadcast("Log", { message: logMessage });
}

export default log;